import * as React from 'react';
import { BrandColor } from '@styleseat/brand';

type MessageIconProps = {
  width?: number;
  height?: number;
  strokeWidth?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const MessageIcon = ({
  width,
  height,
  color,
  strokeWidth,
  ...restProps
}: MessageIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.00004 14.5358L8.0579 11.9997H13.3334C14.0698 11.9997 14.6667 11.4027 14.6667 10.6663V2.66634C14.6667 1.92996 14.0698 1.33301 13.3334 1.33301H2.66671C1.93033 1.33301 1.33337 1.92996 1.33337 2.66634V10.6663C1.33337 11.4027 1.93033 11.9997 2.66671 11.9997H4.00004V14.5358ZM7.67551 10.6663L5.33337 12.1302V10.6663H2.66671V2.66634H13.3334V10.6663H7.67551ZM4.66671 8.66634V7.33301H9.33337V8.66634H4.66671ZM4.66671 4.66634V5.99967H10.6667V4.66634H4.66671Z"
      fill={color}
    />
  </svg>

);

MessageIcon.defaultProps = {
  width: 24,
  height: 24,
  color: BrandColor.BackInBlack,
  strokeWidth: 1.5,
};

export default MessageIcon;
